module.exports = __webpack_public_path__ + "img/IMG_8006 edit.803a01f9.webp";